// Theme variables for the portfolio.
// Kept lightTheme / DarkTheme for any legacy imports, plus a refined
// `portfolio` palette used across the redesigned single-page site.

export const lightTheme = {
    body: "#FCF6F4",
    text: "#000000",
    fontFamily: "'Karla', sans-serif",
    bodyRgba: "252, 246, 244",
    textRgba: "0,0,0",
}

export const DarkTheme = {
    body: "#000000",
    text: "#FCF6F4",
    fontFamily: "'Karla', sans-serif",
    textRgba: "252, 246, 244",
    bodyRgba: "0,0,0",
}

// Single, consistent dark palette with one desaturated emerald accent
// (a quiet nod to telecom heritage) for the redesigned portfolio.
export const portfolio = {
    bg: "#0d0f12",
    bgAlt: "#111419",
    surface: "#161a20",
    surfaceHi: "#1c2128",
    border: "rgba(236, 233, 227, 0.10)",
    borderHi: "rgba(236, 233, 227, 0.22)",

    text: "#ECE9E3",
    muted: "rgba(236, 233, 227, 0.58)",
    faint: "rgba(236, 233, 227, 0.40)",

    accent: "#5BC8A5",
    accentDim: "rgba(91, 200, 165, 0.14)",
    accentRgba: "91, 200, 165",

    display: "'Space Grotesk', sans-serif",
    body: "'Karla', sans-serif",
    mono: "'JetBrains Mono', monospace",
}
